module.exports={
	"Form": "ProductViewManifest",
	"Scope": "Product-View",
	"Descriptors":
	{
		"ProductDetails.Name":
		{
			"Name": "Name",
			"Hash": "Product-View-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 6,
				"Section": "Product-View-Identity",
				"Group": "Product-View-Identity"
			}
		},
		"ProductDetails.ManufacturerCode":
		{
			"Name": "Manufacturer Code",
			"Hash": "Product-View-ManufacturerCode",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 4,
				"Section": "Product-View-Identity",
				"Group": "Product-View-Identity"
			}
		},
		"ProductDetails.CatalogCode":
		{
			"Name": "Catalog Code",
			"Hash": "Product-View-CatalogCode",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "2",
				"Width": 4,
				"Section": "Product-View-Identity",
				"Group": "Product-View-Identity"
			}
		},
		"ProductDetails.AcceptanceMethod":
		{
			"Name": "Acceptance Method",
			"Hash": "Product-View-AcceptanceMethod",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "3",
				"Width": 4,
				"Section": "Product-View-Details",
				"Group": "Product-View-Details"
			}
		},
		"ProductDetails.ProductCategory":
		{
			"Name": "Product Category",
			"Hash": "Product-View-ProductCategory",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "3",
				"Width": 4,
				"Section": "Product-View-Details",
				"Group": "Product-View-Details"
			}
		},
		"ProductDetails.EffectiveDate":
		{
			"Name": "Effective Date",
			"Hash": "Product-View-EffectiveDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "3",
				"Width": 4,
				"Section": "Product-View-Details",
				"Group": "Product-View-Details"
			}
		},
		"ProductDetails.ExpirationDate":
		{
			"Name": "Expiration Date",
			"Hash": "Product-View-ExpirationDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 4,
				"Section": "Product-View-Details",
				"Group": "Product-View-Details"
			}
		},
		"ProductDetails.Comments":
		{
			"Name": "Comments",
			"Hash": "Product-View-Comments",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 12,
				"Section": "Product-View-Details",
				"Group": "Product-View-Details"
			}
		},
		"ProductDetails.IDMaterial":
		{
			"Name": "Material",
			"Hash": "Product-View-IDMaterial",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "6",
				"Width": 4,
				"Section": "Product-View-Details",
				"Group": "Product-View-Details",
				"Entity": "Material",
				"SearchFields":
				[
					"Name",
					"MaterialCode",
					"ItemCode"
				],
				"ReadOnly": true
			}
		},
		"ProductDetails.IDOrganization":
		{
			"Name": "Organization",
			"Hash": "Product-View-IDOrganization",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "6",
				"Width": 4,
				"Section": "Product-View-Details",
				"Group": "Product-View-Details",
				"Entity": "Organization",
				"SearchFields":
				[
					"Name",
					"VendorCode",
					"FederalTaxCode"
				],
				"ReadOnly": true
			}
		},
		"ProductDetails.IDProduct":
		{
			"Name": "IDProduct",
			"Hash": "Product-View-IDProduct",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "7",
				"Width": 4,
				"Section": "Product-View-DataAudit",
				"Group": "Product-View-DataAudit"
			}
		},
		"ProductDetails.GUIDProduct":
		{
			"Name": "GUIDProduct",
			"Hash": "Product-View-GUIDProduct",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "7",
				"Width": 4,
				"Section": "Product-View-DataAudit",
				"Group": "Product-View-DataAudit"
			}
		},
		"ProductDetails.CreateDate":
		{
			"Name": "Create Date",
			"Hash": "Product-View-CreateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "7",
				"Width": 4,
				"Section": "Product-View-DataAudit",
				"Group": "Product-View-DataAudit"
			}
		},
		"ProductDetails.CreatingIDUser":
		{
			"Name": "Creating IDUser",
			"Hash": "Product-View-CreatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "8",
				"Width": 4,
				"Section": "Product-View-DataAudit",
				"Group": "Product-View-DataAudit"
			}
		},
		"ProductDetails.UpdateDate":
		{
			"Name": "Update Date",
			"Hash": "Product-View-UpdateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "8",
				"Width": 4,
				"Section": "Product-View-DataAudit",
				"Group": "Product-View-DataAudit"
			}
		},
		"ProductDetails.UpdatingIDUser":
		{
			"Name": "Updating IDUser",
			"Hash": "Product-View-UpdatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "8",
				"Width": 4,
				"Section": "Product-View-DataAudit",
				"Group": "Product-View-DataAudit"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "Product-View-Identity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "Product-View-Identity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Details",
			"Hash": "Product-View-Details",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Details",
					"Hash": "Product-View-Details",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Data Audit",
			"Hash": "Product-View-DataAudit",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Data Audit",
					"Hash": "Product-View-DataAudit",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}
